import cn from "classnames"

import { Button, Img } from "ui-kit/components-branded/index"
import { Input } from "ui-kit/components-branded/FormControls/Input/Input"

interface Props {
    isShowLabel: boolean
    promoCode: string
    promoCodeDisabled?: boolean
    promoCodeSuccess?: string
    promoCodeError?: string
    onPromoCodeChange: (promoCode: string) => void
    onPromoCodeSelect?: () => void
    onApplyPromoCode: () => Promise<void>
    hasPreviousSessions?: boolean
    focusOnPromoCode?: boolean
}

export const PromoCode = (props: Props) => {
    return (
        <label htmlFor="promoCode" className="is-block discount__promocode">
            <div className="mt-2">
                <div className="is-flex is-align-items-flex-start">
                    <Input
                        autoFocus={!!(props.hasPreviousSessions || props.focusOnPromoCode)}
                        error={props.promoCodeError}
                        disabled={props.promoCodeDisabled}
                        isMiddleSpacesAllowed
                        {...(props.isShowLabel ? { label: "Промокод" } : {})}
                        {...(props.isShowLabel
                            ? { labelIcon: <Img src="discounts.png" width={18} height={16} /> }
                            : {})}
                        name="promoCode"
                        success={props.promoCodeSuccess}
                        testId="promoCode"
                        value={props.promoCode}
                        onChange={props.onPromoCodeChange}
                        onFocus={props.onPromoCodeSelect}
                    />
                    <Button
                        className={cn("ml-2 discount__button", {
                            "discount__button--mt": props.isShowLabel,
                        })}
                        onClick={() => void props.onApplyPromoCode()}
                        disabled={
                            props.promoCodeDisabled ||
                            props.promoCodeError !== undefined ||
                            !props.promoCode
                        }
                    >
                        Применить
                    </Button>
                </div>
            </div>
        </label>
    )
}
